<!-- ======== NAVBAR (same as Home page) ======== -->
<nav class="insc-navbar">
  <div class="nav-content">
    <a class="nav-brand" routerLink="/home">
      <img [src]="logoSrc" alt="GardeKids" class="brand-logo-img" />
    </a>
    <div class="nav-actions">
      <a class="nav-link" routerLink="/home">{{ 'SUBSCRIPTION.NAV.HOME' | translate }}</a>
      <a class="btn-subscribe-pill" routerLink="/authentication/signin">
        {{ 'SUBSCRIPTION.NAV.LOGIN' | translate }}
      </a>
    </div>
  </div>
</nav>

<!-- Success View -->
@if (submissionSuccess) {
<section class="success-section">
  <div class="success-container">
    <div class="success-icon-wrapper">
      <mat-icon class="success-icon">check_circle</mat-icon>
    </div>
    <h1>{{ 'SUBSCRIPTION.SUCCESS.TITLE' | translate }}</h1>
    <p class="success-message">{{ 'SUBSCRIPTION.SUCCESS.MESSAGE' | translate:{ email: submittedEmail } }}</p>
    <p class="success-info">{{ 'SUBSCRIPTION.SUCCESS.INFO' | translate }}</p>
    <div class="success-card">
      <mat-icon>email</mat-icon>
      <span>{{ 'SUBSCRIPTION.SUCCESS.CHECK_EMAIL' | translate }}</span>
    </div>
    <button class="btn-primary-pill" routerLink="/home">
      <mat-icon>home</mat-icon>
      {{ 'SUBSCRIPTION.SUCCESS.BACK_HOME' | translate }}
    </button>
  </div>
</section>
} @else {

<!-- ======== HERO BANNER ======== -->
<section class="hero-section">
  <div class="hero-content">
    <div class="hero-text">
      <h1>{{ 'SUBSCRIPTION.HERO.TITLE' | translate }}</h1>
      <p>{{ 'SUBSCRIPTION.HERO.SUBTITLE' | translate }}</p>
    </div>
    <div class="hero-visual">
      <div class="hero-badge">
        <mat-icon>check_circle</mat-icon>
        <span>{{ 'SUBSCRIPTION.HERO.BADGE1' | translate }}</span>
      </div>
      <div class="hero-badge">
        <mat-icon>visibility</mat-icon>
        <span>{{ 'SUBSCRIPTION.HERO.BADGE2' | translate }}</span>
      </div>
      <div class="hero-badge">
        <mat-icon>forum</mat-icon>
        <span>{{ 'SUBSCRIPTION.HERO.BADGE3' | translate }}</span>
      </div>
    </div>
  </div>
</section>

<!-- ======== STEP PROGRESS ======== -->
@if (!submissionSuccess) {
<div class="step-progress-bar">
  <div class="step-progress-container">
    @for (step of [0, 1, 2, 3]; track step) {
    <div class="step-item" [class.active]="currentStep === step" [class.completed]="currentStep > step"
      (click)="goToStep(step)">
      <div class="step-circle">
        @if (currentStep > step) {
        <mat-icon>check</mat-icon>
        } @else {
        <span>{{ step + 1 }}</span>
        }
      </div>
      <span class="step-label">
        @switch (step) {
        @case (0) { {{ 'SUBSCRIPTION.STEPS.SCHOOL' | translate }} }
        @case (1) { {{ 'SUBSCRIPTION.STEPS.PARENT' | translate }} }
        @case (2) { {{ 'SUBSCRIPTION.STEPS.CHILDREN' | translate }} }
        @case (3) { {{ 'SUBSCRIPTION.STEPS.CONFIRM' | translate }} }
        }
      </span>
    </div>
    @if (step < 3) {
    <div class="step-connector" [class.completed]="currentStep > step"></div>
    }
    }
  </div>
</div>
}

<!-- Main Content -->
<section class="main-content">
  <div class="content-container">

    <!-- STEP 0: Search School -->
    @if (currentStep === 0) {
    <div class="step-card animate-in">
      <div class="step-header">
        <mat-icon class="step-icon">search</mat-icon>
        <div>
          <h2>{{ 'SUBSCRIPTION.SEARCH.TITLE' | translate }}</h2>
          <p>{{ 'SUBSCRIPTION.SEARCH.SUBTITLE' | translate }}</p>
        </div>
      </div>

      <div class="search-box">
        <mat-form-field class="search-field" appearance="outline">
          <mat-label>{{ 'SUBSCRIPTION.SEARCH.PLACEHOLDER' | translate }}</mat-label>
          <input matInput [value]="searchTerm" (input)="onSearchChange($any($event.target).value)"
            autocomplete="off">
          <mat-icon matPrefix>search</mat-icon>
        </mat-form-field>
      </div>

      <div class="school-filters">
        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Type d'établissement</mat-label>
          <mat-select [(ngModel)]="filterType" (selectionChange)="onFilterChange()">
            <mat-option value="">Tous</mat-option>
            <mat-option value="Garderie">Garderie</mat-option>
            <mat-option value="Crèche">Crèche</mat-option>
            <mat-option value="maternelle">École maternelle</mat-option>
            @for (t of schoolTypes; track t) {
              <mat-option [value]="t">{{ t }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Ville / zone</mat-label>
          <input matInput [(ngModel)]="filterCity" (input)="onFilterChange()" placeholder="Ex: Tunis" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Région</mat-label>
          <input matInput [(ngModel)]="filterRegion" (input)="onFilterChange()" placeholder="Ex: Tunis" />
        </mat-form-field>
      </div>

      @if (isSearching) {
      <div class="loading-indicator">
        <mat-progress-spinner diameter="40" mode="indeterminate"></mat-progress-spinner>
      </div>
      }

      @if (!isSearching && searchResults.length === 0 && searchTerm) {
      <div class="no-results">
        <mat-icon>search_off</mat-icon>
        <p>{{ 'SUBSCRIPTION.SEARCH.NO_RESULTS' | translate }}</p>
      </div>
      }

      <div class="schools-grid">
        @for (school of searchResults; track school.id) {
        <div class="school-card" [class.selected]="selectedSchool?.id === school.id" (click)="selectSchool(school)">
          <div class="school-card-header">
            <img [src]="school.logo || 'assets/images/banner/1.png'" [alt]="school.school_name" class="school-logo"
              onerror="this.src='assets/images/banner/1.png'">
            <div class="school-info">
              <h3>{{ school.school_name }}</h3>
              <span class="school-type-badge">{{ school.type }}</span>
            </div>
          </div>
          <div class="school-card-body">
            @if (school.description) {
            <div class="school-detail">
              <mat-icon>info</mat-icon>
              <span>{{ school.description }}</span>
            </div>
            }
          </div>
          <div class="school-card-footer">
            <div class="capacity-badge" [class.available]="school.available_capacity > 0"
              [class.full]="school.available_capacity <= 0">
              <mat-icon>{{ school.available_capacity > 0 ? 'event_available' : 'block' }}</mat-icon>
              @if (school.available_capacity > 0) {
              <span>{{ school.available_capacity }} {{ 'SUBSCRIPTION.SEARCH.SPOTS' | translate }}</span>
              } @else {
              <span>{{ 'SUBSCRIPTION.SEARCH.FULL' | translate }}</span>
              }
            </div>
            @if (school.available_capacity > 0) {
            <button class="select-btn" (click)="selectSchool(school); $event.stopPropagation()">
              {{ 'SUBSCRIPTION.SEARCH.SELECT' | translate }}
              <mat-icon>arrow_forward</mat-icon>
            </button>
            }
          </div>
        </div>
        }
      </div>
    </div>
    }

    <!-- STEP 1: Parent Information -->
    @if (currentStep === 1) {
    <div class="step-card animate-in">
      <!-- Selected school banner -->
      <div class="selected-school-banner">
        <img [src]="selectedSchool?.logo || 'assets/images/banner/1.png'" class="mini-logo" onerror="this.src='assets/images/banner/1.png'">
        <div>
          <strong>{{ selectedSchool?.school_name }}</strong>
          <small>{{ selectedSchool?.type }}</small>
        </div>
        <button mat-button class="change-btn" (click)="changeSchool()">
          <mat-icon>swap_horiz</mat-icon> {{ 'SUBSCRIPTION.SEARCH.CHANGE' | translate }}
        </button>
      </div>

      <div class="step-header">
        <mat-icon class="step-icon">person</mat-icon>
        <div>
          <h2>{{ 'SUBSCRIPTION.PARENT_FORM.TITLE' | translate }}</h2>
          <p>{{ 'SUBSCRIPTION.PARENT_FORM.SUBTITLE' | translate }}</p>
        </div>
      </div>

      <form [formGroup]="parentForm" class="inscription-form">
        <div class="row">
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{ 'COMMON.FIELDS.FIRST_NAME' | translate }}</mat-label>
              <input matInput formControlName="firstName">
              <mat-icon matPrefix>person</mat-icon>
              @if (parentForm.get('firstName')?.hasError('required') && parentForm.get('firstName')?.touched) {
              <mat-error>{{ 'COMMON.VALIDATIONS.REQUIRED' | translate }}</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{ 'COMMON.FIELDS.LAST_NAME' | translate }}</mat-label>
              <input matInput formControlName="lastName">
              <mat-icon matPrefix>person</mat-icon>
              @if (parentForm.get('lastName')?.hasError('required') && parentForm.get('lastName')?.touched) {
              <mat-error>{{ 'COMMON.VALIDATIONS.REQUIRED' | translate }}</mat-error>
              }
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{ 'COMMON.FIELDS.EMAIL' | translate }}</mat-label>
              <input matInput formControlName="email" type="email">
              <mat-icon matPrefix>email</mat-icon>
              @if (parentForm.get('email')?.hasError('required') && parentForm.get('email')?.touched) {
              <mat-error>{{ 'COMMON.VALIDATIONS.EMAIL_REQUIRED' | translate }}</mat-error>
              }
              @if (parentForm.get('email')?.hasError('email') && parentForm.get('email')?.touched) {
              <mat-error>{{ 'COMMON.VALIDATIONS.EMAIL_INVALID' | translate }}</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{ 'COMMON.FIELDS.PHONE_NUMBER' | translate }}</mat-label>
              <input matInput formControlName="phoneNumber" placeholder="+216XXXXXXXX">
              <mat-icon matPrefix>phone</mat-icon>
              @if (parentForm.get('phoneNumber')?.hasError('required') && parentForm.get('phoneNumber')?.touched) {
              <mat-error>{{ 'COMMON.VALIDATIONS.REQUIRED' | translate }}</mat-error>
              }
              @if (parentForm.get('phoneNumber')?.hasError('pattern') && parentForm.get('phoneNumber')?.touched) {
              <mat-error>Format: +216XXXXXXXX</mat-error>
              }
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{ 'COMMON.FIELDS.SECOND_PHONE' | translate }}</mat-label>
              <input matInput formControlName="secondPhoneNumber" placeholder="+216XXXXXXXX">
              <mat-icon matPrefix>phone_android</mat-icon>
              @if (parentForm.get('secondPhoneNumber')?.hasError('pattern') && parentForm.get('secondPhoneNumber')?.touched) {
              <mat-error>Format: +216XXXXXXXX</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{ 'SUBSCRIPTION.PARENT_FORM.CIVIL_STATE' | translate }}</mat-label>
              <mat-select formControlName="civilState">
                <mat-option value="SINGLE">{{ 'SUBSCRIPTION.PARENT_FORM.SINGLE' | translate }}</mat-option>
                <mat-option value="MARRIED">{{ 'SUBSCRIPTION.PARENT_FORM.MARRIED' | translate }}</mat-option>
                <mat-option value="DIVORCED">{{ 'SUBSCRIPTION.PARENT_FORM.DIVORCED' | translate }}</mat-option>
                <mat-option value="WIDOWED">{{ 'SUBSCRIPTION.PARENT_FORM.WIDOWED' | translate }}</mat-option>
              </mat-select>
              <mat-icon matPrefix>family_restroom</mat-icon>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{ 'COMMON.FIELDS.REGION' | translate }}</mat-label>
              <input matInput formControlName="region" placeholder="Ex: Tunis, Sousse...">
              <mat-icon matPrefix>map</mat-icon>
            </mat-form-field>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{ 'COMMON.FIELDS.CITY' | translate }}</mat-label>
              <input matInput formControlName="city" placeholder="Ex: Ariana, Monastir...">
              <mat-icon matPrefix>location_city</mat-icon>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>{{ 'COMMON.FIELDS.ADDRESS' | translate }}</mat-label>
              <input matInput formControlName="address" placeholder="Rue, numéro, complément...">
              <mat-icon matPrefix>location_on</mat-icon>
            </mat-form-field>
          </div>
        </div>
      </form>

      <div class="step-actions">
        <button class="btn-back-pill" (click)="prevStep()">
          <mat-icon>arrow_back</mat-icon> {{ 'COMMON.ACTIONS.BACK' | translate }}
        </button>
        <button class="btn-primary-pill" (click)="nextStep()" [disabled]="parentForm.invalid">
          {{ 'COMMON.ACTIONS.NEXT' | translate }} <mat-icon>arrow_forward</mat-icon>
        </button>
      </div>
    </div>
    }

    <!-- STEP 2: Children Information -->
    @if (currentStep === 2) {
    <div class="step-card animate-in">
      <div class="step-header">
        <mat-icon class="step-icon">child_care</mat-icon>
        <div>
          <h2>{{ 'SUBSCRIPTION.CHILD_FORM.TITLE' | translate }}</h2>
          <p>{{ 'SUBSCRIPTION.CHILD_FORM.SUBTITLE' | translate }}</p>
        </div>
      </div>

      <form [formGroup]="childrenForm" class="inscription-form">
        <div formArrayName="children">
          @for (child of childrenArray.controls; track $index; let i = $index) {
          <div class="child-card" [formGroupName]="i">
            <div class="child-card-header">
              <div class="child-number">
                <mat-icon>face</mat-icon>
                <span>{{ 'SUBSCRIPTION.CHILD_FORM.CHILD_NUMBER' | translate:{ number: i + 1 } }}</span>
              </div>
              @if (childrenArray.length > 1) {
              <button mat-icon-button class="remove-child-btn" (click)="removeChild(i)"
                matTooltip="{{ 'SUBSCRIPTION.CHILD_FORM.REMOVE_CHILD' | translate }}">
                <mat-icon>close</mat-icon>
              </button>
              }
            </div>

            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                <mat-form-field class="full-width" appearance="outline">
                  <mat-label>{{ 'COMMON.FIELDS.FIRST_NAME' | translate }}</mat-label>
                  <input matInput formControlName="firstName">
                  <mat-icon matPrefix>person</mat-icon>
                </mat-form-field>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                <mat-form-field class="full-width" appearance="outline">
                  <mat-label>{{ 'COMMON.FIELDS.LAST_NAME' | translate }}</mat-label>
                  <input matInput formControlName="lastName">
                  <mat-icon matPrefix>person</mat-icon>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                <mat-form-field class="full-width" appearance="outline">
                  <mat-label>{{ 'COMMON.FIELDS.DATE_OF_BIRTH' | translate }}</mat-label>
                  <input matInput [matDatepicker]="childDobPicker" [max]="maxBirthDate" formControlName="birthDate">
                  <mat-datepicker-toggle matSuffix [for]="childDobPicker"></mat-datepicker-toggle>
                  <mat-datepicker #childDobPicker></mat-datepicker>
                  <mat-icon matPrefix>cake</mat-icon>
                </mat-form-field>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                <mat-form-field class="full-width" appearance="outline">
                  <mat-label>{{ 'COMMON.FIELDS.GENDER' | translate }}</mat-label>
                  <mat-select formControlName="gender">
                    <mat-option value="MALE">{{ 'COMMON.FIELDS.MALE' | translate }}</mat-option>
                    <mat-option value="FEMALE">{{ 'COMMON.FIELDS.FEMALE' | translate }}</mat-option>
                  </mat-select>
                  <mat-icon matPrefix>wc</mat-icon>
                </mat-form-field>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                <mat-form-field class="full-width" appearance="outline">
                  <mat-label>{{ 'SUBSCRIPTION.CHILD_FORM.LEVEL' | translate }}</mat-label>
                  <mat-select formControlName="levelId">
                    @for (level of schoolLevels; track level.id) {
                    <mat-option [value]="level.id">{{ level.level_name }}</mat-option>
                    }
                  </mat-select>
                  <mat-icon matPrefix>school</mat-icon>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <mat-form-field class="full-width" appearance="outline">
                  <mat-label>{{ 'SUBSCRIPTION.CHILD_FORM.REMARKS' | translate }}</mat-label>
                  <textarea matInput formControlName="remarks" rows="2"></textarea>
                  <mat-icon matPrefix>notes</mat-icon>
                </mat-form-field>
              </div>
            </div>
          </div>
          }
        </div>
      </form>

      <button mat-stroked-button class="add-child-btn" (click)="addChild()">
        <mat-icon>add_circle</mat-icon>
        {{ 'SUBSCRIPTION.CHILD_FORM.ADD_CHILD' | translate }}
      </button>

      <div class="step-actions">
        <button class="btn-back-pill" (click)="prevStep()">
          <mat-icon>arrow_back</mat-icon> {{ 'COMMON.ACTIONS.BACK' | translate }}
        </button>
        <button class="btn-primary-pill" (click)="nextStep()" [disabled]="childrenForm.invalid">
          {{ 'COMMON.ACTIONS.NEXT' | translate }} <mat-icon>arrow_forward</mat-icon>
        </button>
      </div>
    </div>
    }

    <!-- STEP 3: Review & Confirm -->
    @if (currentStep === 3) {
    <div class="step-card animate-in">
      <div class="step-header">
        <mat-icon class="step-icon">fact_check</mat-icon>
        <div>
          <h2>{{ 'SUBSCRIPTION.REVIEW.TITLE' | translate }}</h2>
          <p>{{ 'SUBSCRIPTION.REVIEW.SUBTITLE' | translate }}</p>
        </div>
      </div>

      <!-- School Review -->
      <div class="review-section">
        <div class="review-section-header">
          <mat-icon>school</mat-icon>
          <h3>{{ 'SUBSCRIPTION.REVIEW.SCHOOL_SECTION' | translate }}</h3>
          <button mat-icon-button class="edit-btn" (click)="goToStep(0)">
            <mat-icon>edit</mat-icon>
          </button>
        </div>
        <div class="review-content">
          <div class="review-row">
            <span class="review-label">{{ 'COMMON.FIELDS.SCHOOL' | translate }}</span>
            <span class="review-value">{{ selectedSchool?.school_name }}</span>
          </div>
          <div class="review-row">
            <span class="review-label">{{ 'COMMON.FIELDS.TYPE' | translate }}</span>
            <span class="review-value">{{ selectedSchool?.type }}</span>
          </div>
        </div>
      </div>

      <!-- Parent Review -->
      <div class="review-section">
        <div class="review-section-header">
          <mat-icon>person</mat-icon>
          <h3>{{ 'SUBSCRIPTION.REVIEW.PARENT_SECTION' | translate }}</h3>
          <button mat-icon-button class="edit-btn" (click)="goToStep(1)">
            <mat-icon>edit</mat-icon>
          </button>
        </div>
        <div class="review-content">
          <div class="review-row">
            <span class="review-label">{{ 'COMMON.FIELDS.FULL_NAME' | translate }}</span>
            <span class="review-value">{{ parentForm.get('firstName')?.value }} {{ parentForm.get('lastName')?.value
              }}</span>
          </div>
          <div class="review-row">
            <span class="review-label">{{ 'COMMON.FIELDS.EMAIL' | translate }}</span>
            <span class="review-value">{{ parentForm.get('email')?.value }}</span>
          </div>
          <div class="review-row">
            <span class="review-label">{{ 'COMMON.FIELDS.PHONE_NUMBER' | translate }}</span>
            <span class="review-value">{{ parentForm.get('phoneNumber')?.value }}</span>
          </div>
        </div>
      </div>

      <!-- Children Review -->
      <div class="review-section">
        <div class="review-section-header">
          <mat-icon>child_care</mat-icon>
          <h3>{{ 'SUBSCRIPTION.REVIEW.CHILDREN_SECTION' | translate }} ({{ childrenArray.length }})</h3>
          <button mat-icon-button class="edit-btn" (click)="goToStep(2)">
            <mat-icon>edit</mat-icon>
          </button>
        </div>
        @for (child of childrenArray.controls; track $index; let i = $index) {
        <div class="review-content child-review">
          <div class="child-review-header">
            <mat-icon>face</mat-icon>
            <strong>{{ child.get('firstName')?.value }} {{ child.get('lastName')?.value }}</strong>
          </div>
          <div class="review-row">
            <span class="review-label">{{ 'COMMON.FIELDS.DATE_OF_BIRTH' | translate }}</span>
            <span class="review-value">{{ child.get('birthDate')?.value }}</span>
          </div>
          <div class="review-row">
            <span class="review-label">{{ 'COMMON.FIELDS.GENDER' | translate }}</span>
            <span class="review-value">{{ child.get('gender')?.value }}</span>
          </div>
          <div class="review-row">
            <span class="review-label">{{ 'SUBSCRIPTION.CHILD_FORM.LEVEL' | translate }}</span>
            <span class="review-value">{{ getSelectedLevelName(child.get('levelId')?.value) }}</span>
          </div>
        </div>
        }
      </div>

      <!-- Terms -->
      <div class="terms-section">
        <mat-checkbox [(ngModel)]="acceptTerms" color="primary">
          {{ 'SUBSCRIPTION.REVIEW.TERMS' | translate }}
        </mat-checkbox>
      </div>

      <div class="step-actions">
        <button class="btn-back-pill" (click)="prevStep()">
          <mat-icon>arrow_back</mat-icon> {{ 'COMMON.ACTIONS.BACK' | translate }}
        </button>
        <button class="btn-submit-pill" (click)="onSubmit()"
          [disabled]="!acceptTerms || isSubmitting">
          @if (isSubmitting) {
          <mat-progress-spinner diameter="20" mode="indeterminate" class="btn-spinner"></mat-progress-spinner>
          {{ 'SUBSCRIPTION.REVIEW.SUBMITTING' | translate }}
          } @else {
          <mat-icon>send</mat-icon>
          {{ 'SUBSCRIPTION.REVIEW.SUBMIT' | translate }}
          }
        </button>
      </div>
    </div>
    }

  </div>
</section>
}

<!-- ======== FOOTER (same as Home page) ======== -->
<footer class="insc-footer">
  <div class="footer-container">
    <div class="footer-main">
      <div class="footer-brand">
        <div class="footer-logo">
          <img [src]="logoSrc" alt="GardeKids" class="footer-logo-img" />
        </div>
        <p>The modern platform for kindergarten management. Simplifying enrollment, payments, and communication.</p>
      </div>
      <div class="footer-links">
        <div class="footer-col">
          <h4>Platform</h4>
          <a routerLink="/home">Home</a>
          <a routerLink="/inscription">Subscribe Now</a>
        </div>
        <div class="footer-col">
          <a routerLink="/authentication/signin">Login</a>
          <a routerLink="/authentication/signup">Register</a>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <span>&copy; {{ currentYear }} GardeKids. {{ 'APP_FOOTER.RIGHTS' | translate }}</span>
    </div>
  </div>
</footer>
